import React, { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  opacity: ${p => p.visible ? 1 : 0};
  transform: translateY(${p => p.visible ? 0 : '24px'});
  transition: opacity 0.7s cubic-bezier(0.16, 1, 0.3, 1),
              transform 0.7s cubic-bezier(0.16, 1, 0.3, 1);
  transition-delay: ${p => p.delay || '0s'};
  will-change: opacity, transform;
`;

export default function ScrollReveal({ children, delay, style }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); observer.unobserve(el); } },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <Wrapper ref={ref} visible={visible} delay={delay} style={style}>
      {children}
    </Wrapper>
  );
}
